import { CultureInfo } from '../culture-info.model';
import { CultureInfoEl } from './el';

/**
 * @ignore
 */
export const CultureInfoElGR: CultureInfo = {
  name: 'el-GR',
  displayName: 'Greek (Greece)',
  iso3LanguageCode: 'ell',
  iso2LanguageCode: 'el',
  ietfLanguageTag: 'el-GR',
  parent: CultureInfoEl
};
